import { render, staticRenderFns } from "./coffee.vue?vue&type=template&id=6b551856&scoped=true&"
import script from "./coffee.vue?vue&type=script&lang=js&"
export * from "./coffee.vue?vue&type=script&lang=js&"
import style0 from "./coffee.vue?vue&type=style&index=0&id=6b551856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b551856",
  null
  
)

export default component.exports